import { Injectable } from '@angular/core';
import { TreeviewItem } from './../../shared/TreePermissions/treeview-item';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RestApi } from "../../shared/RestApi/restApi";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { TreeNode } from 'primeng/api';

interface permissionsDetails {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
/*
Author:Ravi G
Date:28-06-2022
*/
export class PermissionsService {
  private headers = new HttpHeaders({ "content-Type": "application/json" });

  constructor(
    private Http: HttpClient,
    private restAPI: RestApi,
    private snackBar: MatSnackBar,
    private router: Router,
    private spinner: NgxUiLoaderService
  ) { }

  getPermissions(permissionNames, permissionsbuttons,screenName,roleid): TreeNode[] {
    var parentNames = [];
    var childNames = [];
    var bothNames = [];
    var anotherBothNames = [];
    var allCategory = [];
    var childrenCategory: any;
    var anotherParentNames = [];
    var subchilds = permissionsbuttons;

    for (var i = 0; i < permissionNames.length; i++) {

      if (permissionNames[i].level == 1) {

        anotherParentNames.push(permissionNames[i]);

      } else {

        childNames.push(permissionNames[i]);

      }

    }

    console.log("permissionNames");

    console.log(permissionNames);

    console.log("screenName");

    console.log(screenName);

    console.log("anotherParentNames");

    console.log(anotherParentNames);

    console.log("childNames");

    console.log(childNames);

    var allAccess;
    
    //Storing the parents into anotherParentMobile which does not have screenId 1002.
    for (let p = 0; p < anotherParentNames.length; p++) {
      if (anotherParentNames[p].screenId == 1001 || anotherParentNames[p].screenId == 1002) {
        allAccess = anotherParentNames[p].access;
      }
      else {
        parentNames.push(anotherParentNames[p]);
      }
    }

    console.log("allAccess");

    console.log(allAccess);

    if (allAccess == 'Yes') {

      console.log("if");

      console.log("allAccess");

      console.log(allAccess);

      console.log("parentNames.length");

      console.log(parentNames.length);
      for (var i = 0; i < parentNames.length; i++) {

        var childPresentInParent = []
        var permissionChecked;
        var buttonPresentInSubScreen = []
        var flag = false;
        var roleids = [];
        if (parentNames[i].hasChild == "true") {
          for (var j = 0; j < childNames.length; j++) {
            if (parentNames[i].screenId == childNames[j].parentScreenId) {
              

              if (childNames[j].access == "Yes") {
                permissionChecked = true;
              }
              if (childNames[j].access == "No") {
                permissionChecked = false;
              }
              /*
               Modified By Chandra R
               Below code upends Buttons(subchildNames) to root Treeviewer
               Date : 28-11-2024
              */
              console.log(subchilds);
              for(var m=0 ; m<subchilds.length;m++)
              {
                if(childNames[j].screenId == subchilds[m].screenid){
                  console.log(subchilds[m])
                  console.log(subchilds[m].roleid)
                  console.log(roleid)
                  if(subchilds[m].roleid != null)
                  {
                    roleids = subchilds[m].roleid.split(',').map(Number);
                    if (roleids.includes(roleid)) {
                      flag = true;
                    }
                  }
                  else{
                    subchilds[m].roleid="";
                  }

                  buttonPresentInSubScreen.push({text: subchilds[m]._icon + subchilds[m].description,checked: flag, value: `Btn${subchilds[m].buttonId}+${childNames[j].screenId}|${subchilds[m]._cssClass}`,itemClass: subchilds[m]._cssClass,tooltip: subchilds[m]._tooltip});

                  console.log("Button Present",buttonPresentInSubScreen)
                  console.log("UpEnded the subchild to root")
                  flag = false
                }
              }

              childPresentInParent.push({ text: childNames[j].screenName, value: childNames[j].screenId, checked: true ,children: buttonPresentInSubScreen});
              buttonPresentInSubScreen =[];
            }
          }
          bothNames.push({ text: parentNames[i].screenName, value: parentNames[i].screenId , collapsed: true, children: childPresentInParent,itemClass: parentNames[i].criticaloperation === 'true' ? 'critical-permission' : 'standard-permission' });
        } else {
          if (parentNames[i].access == "Yes") {
            permissionChecked = true;
          }
          if (parentNames[i].access == "No") {
            permissionChecked = false;
          }
          bothNames.push({ text: parentNames[i].screenName, value: parentNames[i].screenId, checked: true });
        }

      }
      
      console.log(bothNames);
      allCategory = [];
      var j = 1;
      console.log(JSON.stringify(bothNames, null, 2));
      for (var i = 0; i < bothNames.length; i++) {
        // childrenCategory = new TreeviewItem(bothNames[i]);
        // allCategory.push(childrenCategory);
        allCategory.push(this.convertToPrimeNode(bothNames[i]));
      }
      console.log(allCategory)
      return allCategory;
    }
    else if (allAccess == 'No') {

      console.log("else if");

      console.log("allAccess");

      console.log(allAccess);
      var buttonPresentInSubScreen = []
        var flag = false;
        var roleids = [];

      for (var i = 0; i < parentNames.length; i++) {

        var childPresentInParent = []

        var permissionChecked;

        console.log("parentNames[i]");

        console.log(parentNames[i]);

        if (parentNames[i].hasChild == "true") {
          for (var j = 0; j < childNames.length; j++) {
            
            if (parentNames[i].screenId == childNames[j].parentScreenId) {
              if (childNames[j].access == "Yes") {
                permissionChecked = true;
              }
              if (childNames[j].access == "No") {
                permissionChecked = false;
              }
              /*
               Modified By Chandra R
               Below code upends Buttons(subchildNames) to root Treeviewer
               Date : 28-11-2024
              */
              for(var m=0 ; m<subchilds.length;m++)
                {
                  if(childNames[j].screenId == subchilds[m].screenid){
                    console.log(subchilds[m])
                    console.log(subchilds[m].roleid)
                    console.log(roleid)
                    if(subchilds[m].roleid != null)
                      {
                        roleids = subchilds[m].roleid.split(',').map(Number);
                        if (roleids.includes(roleid)) {
                          flag = true;
                        }
                      }
                      else{
                        subchilds[m].roleid="";
                      }
                    console.log("subchilds",subchilds[m])
   
                    buttonPresentInSubScreen.push({ text: subchilds[m]._icon + subchilds[m].description,checked: flag,value: `Btn${subchilds[m].buttonId}+${childNames[j].screenId}|${subchilds[m]._cssClass}`,itemClass: subchilds[m]._cssClass,tooltip: subchilds[m]._tooltip});

    
                    console.log("Button Present",buttonPresentInSubScreen)

                    console.log("UpEnded the subchild to root")
                    flag = false
                  }
                }
              childPresentInParent.push({ text: childNames[j].screenName, value: childNames[j].screenId, checked: permissionChecked ,children: buttonPresentInSubScreen,    itemClass: childNames[j].criticaloperation === 'true' ? 'critical-permission' : 'standard-permission'   });
              buttonPresentInSubScreen =[];
            }
          }
          bothNames.push({ text: parentNames[i].screenName, value: parentNames[i].screenId , collapsed: true, children: childPresentInParent , itemClass: parentNames[i].criticaloperation === 'true' ? 'critical-permission' : 'standard-permission' });
        } else {
          if (parentNames[i].access == "Yes") {
            permissionChecked = true;
          }
          if (parentNames[i].access == "No") {
            permissionChecked = false;
          }
          bothNames.push({ text: parentNames[i].screenName, value: parentNames[i].screenId, checked: permissionChecked, itemClass: parentNames[i].criticaloperation === 'true' ? 'critical-permission' : 'standard-permission' });
        }

      }

      allCategory = [];

      var j = 1;
      console.log(JSON.stringify(bothNames, null, 2));
      for (var i = 0; i < bothNames.length; i++) {
        //  const processedItem = this.propagateItemClass(bothNames[i]);
        // childrenCategory = new TreeviewItem(bothNames[i]);

        // allCategory.push(childrenCategory);
        allCategory.push(this.convertToPrimeNode(bothNames[i]));

      }
      console.log("allCategory");
      
      console.log(allCategory);
      return allCategory;
    }
  }
  private convertToPrimeNode(
  item: any,
  parent?: TreeNode
): TreeNode {

  const node: TreeNode = {
    label: item.text,
    key: String(item.value),
    expanded: !item.collapsed,
    styleClass: item.itemClass,
    selectable: true,
    data: {
      tooltip: item.tooltip,
      checked: item.checked
    },
    parent: parent,
    children: []
  };
  if (parent) {
  console.log(
    'Assigning parent',
    item.text,
    '=>',
    parent.label
  );
}

  if (item.children) {
    node.children = item.children.map(child =>
      this.convertToPrimeNode(child, node)
    );
  }

  return node;
}


  /*
   Modified By Chandra R
   Below code retrieves Buttons PermissionNames
   Date : 28-11-2024
  */
  async retrievePermissionNamesService(screenType, userId) {

    this.spinner.start();

    console.log(userId);

    console.log("userId");

    console.log(this.restAPI.retrievePermissionNames + "/" + screenType + "/" + userId);

    let response = await this.Http.get<permissionsDetails>(this.restAPI.retrievePermissionNames + "/" + screenType + "/" + userId, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

 
  /*
   Modified By Chandra R
   Below code retrieves Buttons PermissionNames
   Date : 28-11-2024
  */
  async retrievesubchildPermissionNamesService(userId) {

    this.spinner.start();

    console.log(userId); 

    let response = await this.Http.get<permissionsDetails>(this.restAPI.retrievebysubchildPermissionNames, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }






  insertPermissionAccess(havingPermissionAccess, screenType, userId) {

    console.log("insertPermissionAccess(havingPermissionAccess,screenType,userId)");

    console.log(havingPermissionAccess);
    if (havingPermissionAccess.length != 0) {
      userId = 0;
    }

    console.log("userId");

    console.log(userId);

    console.log("havingPermissionAccess");

    console.log(havingPermissionAccess);

    console.log(this.restAPI.updatePermissionAccess + "/" + screenType + "/" + userId);
    
    return this.Http.post<permissionsDetails>(this.restAPI.updatePermissionAccess + "/" + screenType + "/" + userId, JSON.stringify(havingPermissionAccess), { headers: this.headers }
    );
  }




insertIntoScreenOperationPermission(ButtonPermissions){
  return this.Http.post<permissionsDetails>(this.restAPI.insertIntoScreenOperationPermission , JSON.stringify(ButtonPermissions), { headers: this.headers });
  
}
}